<template>
  <router-view />
</template>

<script>
export default {
  name: 'BaseLayout',
}
</script>